import Axios from "axios";

import { apiUrl, serializeObjToGetStr } from "../../constants";

const deviceTypeBaseUrl = `${apiUrl}/deviceType`;
const config = {
    headers: { "Content-Type": "application/json-patch+json" }
};

export const deviceTypesApi = {
  getAll: request => {
    const query = serializeObjToGetStr(request);
    return Axios.get(`${deviceTypeBaseUrl}?${query}`);
  },
  save: deviceType => {
    return Axios.post(deviceTypeBaseUrl, deviceType, config);
  },
  delete: id => {
    return Axios.delete(`${deviceTypeBaseUrl}/${id}`, config);
  },
  upload: (file) => {
    const formData = new FormData();
    formData.append("file", file);

    return Axios.post(`${deviceTypeBaseUrl}/import`, formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
  }
};
